import React from 'react';
import cns from 'classnames';
import PropTypes from 'prop-types';

const SleekLoadingIndicator = (props) => {
    const { className } = props;

    return <div className={cns('sleek-loading-indicator', className)}></div>;
};

SleekLoadingIndicator.propTypes = {
    className: PropTypes.string
};

export default SleekLoadingIndicator;
